<div class="change-cust-main">
  <div class="notification-content">
    <div class="notification-header">
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        (click)="close()"
      >
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="notification-body">
      <div class="notification-item">
        <!-- For guest user -->
        <ng-container *ngIf="loggerIn; else notLoggedIn">
          <ng-container *ngIf="user$ | async as user">
            <div class="userName">
              <bh-avatar
                type="primary"
                size="large"
                ring
                [firstname]="user.firstName?.split(' ')[0]"
                [lastname]="user.lastName?.split(' ')[0]"
              ></bh-avatar>
              <div class="user-id-containr">
                <div class="user-id-and-name">
                  <h3 class="user-name-text">{{ user.name }}</h3>
                  <div class="user-email-text">
                    {{ user.email | lowercase }}
                  </div>
                </div>

                <ds-waygate-customer-account
                  (closeMenu)="onAvatarClick()"
                ></ds-waygate-customer-account>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-template #notLoggedIn>
          <div class="site-logins">
            <bh-button
              (click)="navToLogin()"
              type="primary"
              label="{{ 'guest-home.login' | cxTranslate }}"
            >
            </bh-button>
            <bh-button
              (click)="onRegisterClick()"
              type="secondary"
              label="{{ 'guest-home.mobileSignIn' | cxTranslate }}"
            >
            </bh-button>
          </div>
        </ng-template>
        <hr width="90%" />
        <app-waygate-nav-bar
        (closeSlider)="close()"
          class="desktop-view"
          [isChooseBrandPage]="isChooseBrandPage"
        ></app-waygate-nav-bar>


        
        <hr width="90%" />

        <div class="menu-list" *ngIf="nodeList.length > 0">
          <ng-container *ngFor="let item of nodeList; let i = index">
            <a
              (click)="getItem(item, $event)"
              *ngIf="item?.styleAttributes"
              class="menu-list-item"
            >
              <span class="menu-list-item--text">
                <span class="material-icons" *ngIf="item?.styleAttributes">
                  {{ item?.styleAttributes }}
                </span>
                {{ item.title }}
              </span>
            </a>
          </ng-container>
        </div>
        <hr width="90%" />

        <div class="last-section">
          <p> <span
            [routerLink]="['/', productLine, 'track-order']"
            class="link-anchor"   (click)="close()"
            >{{ 'waygate.trackOrder' | cxTranslate }}</span
          > </p>
          <p><span [routerLink]="contactUsUrl" class="link-anchor"  (click)="close()">{{ 'waygate.contactUs' | cxTranslate }}</span></p>
          <p><span class="link-anchor"  (click)="signOut()">{{ 'siteLogin.signOut' | cxTranslate }}</span></p>
        </div>
      </div>
    </div>
  </div>
</div>
